// @flow

export const BASE_URL_BACKEND: string = process.env.REACT_APP_BASE_URL_BACKEND || "";
export const SCHEMA_DOMAIN: string = process.env.REACT_APP_SCHEMA_DOMAIN || "";
export const SCHEMA_NAME: string = process.env.REACT_APP_SCHEMA_NAME || "";